<ng-container *ngIf="permConfig.isEditAllowed">
<div class="container-fluid">
    <app-page-title title="Sales Invoice Generation"></app-page-title>
    <form [formGroup]="invoiceForm" (ngSubmit)="isFormSubmitted=true;updateInvoice()">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="company" class="form-label">Company</label>
                                    <ng-select id="company" formControlName="ddlCompany" [items]="companyList"
                                        [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'" appEnterDirective
                                        [onEnterKey]="useEnterKey">
                                        <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                            <span>{{ item.name }}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="paymentmode" class="form-label">Payment Type</label>
                                    <ng-select id="paymentmode" placeholder="Select" formControlName="ddlPaymentType"
                                        [items]="paymentOptions" bindLabel="name" [appendTo]="'body'" [openOnEnter]="false"
                                        [bindValue]="'name'" [clearable]="false" appEnterDirective
                                        [onEnterKey]="useEnterKey"></ng-select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="invoiceDate" class="form-label">Invoice Date<span
                                            class="mandatory">*</span></label>
                                    <input id="invoiceDate" class="form-control form-control-sm" type="date"
                                        placeholder="Select" formControlName="txtInvoiceDate" appEnterDirective
                                        [onEnterKey]="useEnterKey">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="InvoiceNo" class="form-label">Invoice No. </label>
                                    <input type="text" formControlName="txtInvoiceNo"
                                        class="form-control form-control-sm" id="InvoiceNo" appEnterDirective
                                        [onEnterKey]="useEnterKey">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="InvoiceNo" class="form-label">Customer</label>
                                    <input type="text" formControlName="txtCustomer"
                                        class="form-control form-control-sm" id="InvoiceNo" disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-12">
                <div class="card">
                    <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">

                        <ngb-panel id="1">
                            <ng-template ngbPanelTitle class="text-black">
                                <i class="bx bx-search text-primary me-1"></i> Search and filter your invoices
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div class="card-body"> 
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="fromDate" class="form-label">From Date<span
                                                        class="mandatory">*</span></label>
                                                <input id="fromDate" class="form-control form-control-sm" type="date"
                                                    placeholder="Select" formControlName="txtFromDate"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtFromDate')?.touched) && invoiceForm.get('txtFromDate').errors}">
                                                <div *ngIf="(isFormSubmitted || invoiceForm.get('txtFromDate')?.touched) && invoiceForm.get('txtFromDate').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="invoiceForm.get('txtFromDate').errors.required">Invoice is
                                                        Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="toDate" class="form-label">To Date<span
                                                        class="mandatory">*</span></label>
                                                <input id="toDate" class="form-control form-control-sm" type="date"
                                                    placeholder="Select" formControlName="txtToDate"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtToDate')?.touched) && invoiceForm.get('txtToDate').errors}">
                                                <div *ngIf="(isFormSubmitted || invoiceForm.get('txtToDate')?.touched) && invoiceForm.get('txtToDate').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="invoiceForm.get('txtToDate').errors.required">Invoice is
                                                        Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="product" class="form-label">Product Type</label>
                                                <ng-select id="product" [items]="productTypeList" placeholder="Select" bindLabel="name" [bindValue]="'name'"
                                                    [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlProductType"></ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="customer" class="form-label">Customer</label>
                                                <ng-select id="customer" [items]="customerList" bindLabel="name" 
                                                    placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCustomer">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="Shipper" class="form-label">Shipper</label>
                                                <input type="text" class="form-control form-control-sm" id="Shipper"
                                                    placeholder="Search or Enter Name" [resultTemplate]="rt"
                                                    [inputFormatter]="formatter" formControlName="txtShipper"
                                                    [ngbTypeahead]="search"/>

                                                <ng-template #rt let-r="result" let-t="term">
                                                    <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                                    <span> | {{ r['code'] }}</span>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label class="form-label" for="vendor">Product</label>
                                                <ng-select id="product" [items]="productList" formControlName="ddlProduct"
                                                    bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label class="form-label" for="vendor">Vendor</label>
                                                <ng-select id="vendor" [items]="vendorList" formControlName="ddlVendor"
                                                    bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                    (change)="bindService()">
                                                </ng-select>

                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label class="form-label" for="service">Service</label>
                                                <ng-select id="service" [items]="serviceList" formControlName="ddlVendorService"
                                                    bindLabel="servicename" [bindValue]="'id'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-6">
                                            <div class="card">
                                                <div class="card-header bg-transparent border-bottom text-uppercase">Origin</div>
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="country" class="form-label">Country</label>
                                                                <ng-select id="country" formControlName="ddlOriginCountry" placeholder="Select"
                                                                    [items]="countryList" bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false" (change)="onCountryChange('origin')">
                                                                </ng-select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="state" class="form-label">State</label>
                                                                <ng-select id="state" formControlName="ddlOriginState" placeholder="Select"
                                                                    [items]="originStateList" bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false" (change)="onStateChange('origin')" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="city" class="form-label">City</label>
                                                                <ng-select id="city" formControlName="ddlOriginCity" placeholder="Select"
                                                                    [appendTo]="'body'" [openOnEnter]="false" [items]="originCityList" bindLabel="name"
                                                                    [bindValue]="'isocode'"/>
                                                            </div>
                                                        </div>
                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="card">
                                                <div class="card-header bg-transparent border-bottom text-uppercase">Destination</div>
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="country" class="form-label">Country</label>
                                                                <ng-select id="country" formControlName="ddlDestinationCountry" placeholder="Select"
                                                                    [items]="countryList" bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false" (change)="onCountryChange()">
                                                                </ng-select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="state" class="form-label">State</label>
                                                                <ng-select id="state" formControlName="ddlDestinationState" placeholder="Select"
                                                                    [items]="destinationStateList" bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false" (change)="onStateChange()" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="city" class="form-label">City</label>
                                                                <ng-select id="city" formControlName="ddlDestinationCity" placeholder="Select"
                                                                    [appendTo]="'body'" [openOnEnter]="false" [items]="destinationCityList" bindLabel="name"
                                                                    [bindValue]="'isocode'" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngb-panel>

                    </ngb-accordion>
                </div>
            </div>
        </div> -->

        <div class="row">
            <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                <ngb-panel id="1">
                    <ng-template ngbPanelTitle class="text-black">
                        <i class="bx bx-flight text-primary me-1"></i>Add AirwayBills
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <form class="col-12" [formGroup]="awbForm" (ngSubmit)="addAWB()">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2 d-flex flex-column">
                                        <div class="label">
                                            <label for="rateFor" class="form-label">Type</label>
                                        </div>
                                        <div role="group" aria-label="radio button group" class="btn-group">
                                            <input type="radio" id="btnradio1" autocomplete="off" class="btn-check"
                                                (change)="typeChange()" formControlName="txtType" value="AWB"
                                                >
                                            <label for="btnradio1" class="btn btn-outline-secondary btn-sm">AWB No.</label>
                                            <input type="radio" id="btnradio2" autocomplete="off" class="btn-check"
                                                (change)="typeChange()" formControlName="txtType" value="DateRange"
                                                >
                                            <label for="btnradio2" class="btn btn-outline-secondary btn-sm">Date
                                                period</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="awbForm.get('txtType').value === 'AWB'">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="AWBNo" class="form-label">AWB No. </label>
                                        <input type="text" formControlName="txtAWBNo" class="form-control form-control-sm"
                                            id="AWBNo"
                                            [ngClass]="{'is-invalid': (isAWBFormSubmitted || awbForm.get('txtAWBNo')?.touched) && awbForm.get('txtAWBNo').errors}"
                                            >
                                        <div *ngIf="(isAWBFormSubmitted || awbForm.get('txtAWBNo')?.touched) && awbForm.get('txtAWBNo').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="awbForm.get('txtAWBNo').errors.required">AWB Number is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2" *ngIf="awbForm.get('txtType').value === 'DateRange'">
                                <div class="col-md-4">
                                    <label for="fromDate" class="form-label">Period Range</label>
                                    <div class="input-daterange input-group" data-provide="datepicker">
                                        <input id="fromDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtFromDate" placeholder="From"
                                            [ngClass]="{'is-invalid': (isAWBFormSubmitted || awbForm.get('txtFromDate').touched) && awbForm.get('txtFromDate').errors}"
                                            >
                                        <div *ngIf="(isAWBFormSubmitted || awbForm.get('txtFromDate').touched) && awbForm.get('txtFromDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="awbForm.get('txtFromDate').errors.required">Date is
                                                required</span>
                                        </div>
                                        <input id="toDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtToDate"
                                            [ngClass]="{'is-invalid': (isAWBFormSubmitted || awbForm.get('txtToDate').touched) && awbForm.get('txtToDate').errors}"
                                            >
                                        <div *ngIf="(isAWBFormSubmitted || awbForm.get('txtToDate').touched) && awbForm.get('txtToDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="awbForm.get('txtToDate').errors.required">Date is
                                                required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="button-items">
                                        <button type="submit" class="btn btn-primary btn-sm" appEnterDirective
                                            [onEnterKey]="useEnterKey">Add</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div *ngIf="!isLock" class="col-md-12 text-sm-end mb-1"
                                style="display: inline-flex; justify-content: end; align-items: center;">
                                <div class="button-items">
                                    <button type="button" class="btn btn-primary btn-sm" (click)="applyRates()"><i
                                            class="mdi mdi-sync me-1"></i>Update Rate</button>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row mb-2" *ngIf="!isLock">
                            <div class="col-12 d-flex justify-content-end">
                              <div ngbDropdown class="d-inline-block dropdown">
                                <button type="button" class="btn btn-secondary btn-sm" ngbDropdownToggle>
                                  Select Action<i class="mdi mdi-chevron-down d-none d-xl-inline-block ms-1"></i>
                                </button>
                                <div ngbDropdownMenu>
                                  <span class="dropdown-item" (click)="addAWB()">
                                    <i class="mdi mdi-plus font-size-16 align-middle me-2"></i>Add Airwaybills</span>
                                  <span class="dropdown-item" [ngClass]="{'disabled-link': !areSelected, 'enabled-link': areSelected}"
                                     (click)="applyRates()">
                                    <i class="mdi mdi-sync font-size-12 align-middle ms-1 me-2"></i>Update Rate</span>
                                </div>
                              </div>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-md-12">
                                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                    class="ag-theme-balham" [rowData]="rowDataAWBWise" [columnDefs]="columnDefsAWBWise"
                                    [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                    [suppressMenuHide]="true" [pagination]="true" [enableCellTextSelection]="true"
                                    (gridReady)="onGridReadyAWBWise($event)" [gridOptions]="gridOptions"
                                    (rowSelected)="onRowSelected()">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="button-items">
                    <button type="submit" class="btn btn-primary w-sm" appEnterDirective
                        [onEnterKey]="useEnterKey">Update</button>
                    <a routerLink="/invoices/sales" >
                        <button type="button" class="btn btn-secondary w-sm">Cancel</button>
                    </a>
                </div>
            </div>
        </div>
    </form>
</div>
</ng-container>
<ng-container *ngIf="!permConfig.isEditAllowed">
    <app-forbidden></app-forbidden>
</ng-container>